import BaseContentLoader from 'react-content-loader';
import styled from 'styled-components';

import colors from '../../../theme/constants/colors';
import { borderSpacing, rowHeight } from '../Table.styled';

export const TablePlaceholderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  background-color: ${colors.pearl};
  border-radius: 12px;

  table {
    width: 100%;
    height: max-content;
    border-spacing: 0 ${borderSpacing}px;
  }

  th {
    pointer-events: none;
  }
`;

export const ContentLoader = styled(BaseContentLoader)`
  width: 100%;
  height: 100%;
`;

export const LoadingRow = styled.rect.attrs({
  rx: 12,
  ry: 12,
  x: 0,
  width: '100%',
  height: rowHeight,
})``;
